var _path, _path2, _polygon, _polygon2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.02,
    y: 82.85,
    width: 48.34,
    height: 153.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.19,
    y: 82.85,
    width: 24.17,
    height: 152.79,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.54,
    y: 67.8,
    width: 17.07,
    height: 15.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.54,
    y: 67.8,
    width: 4.07,
    height: 15.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122.99 82.85 122.99 81.97 176.78 81.97 176.78 82.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 89.41,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,101.42c0,.09-5.41.17-12.09.17s-12.08-.08-12.08-.17,5.41-.16,12.08-.16S151.19,101.33,151.19,101.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 89.41,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,101.42c0,.09-5.41.17-12.08.17s-12.09-.08-12.09-.17,5.41-.16,12.09-.16S175.57,101.33,175.57,101.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 106.54,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,118.55c0,.09-5.41.17-12.08.17s-12.09-.08-12.09-.17,5.41-.16,12.09-.16S175.57,118.46,175.57,118.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 124.18,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,136.2c0,.09-5.41.16-12.08.16s-12.09-.07-12.09-.16,5.41-.16,12.09-.16S175.57,136.11,175.57,136.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 141.83,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,153.85c0,.09-5.41.16-12.08.16s-12.09-.07-12.09-.16,5.41-.17,12.09-.17S175.57,153.76,175.57,153.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 158.98,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,171c0,.09-5.41.17-12.08.17s-12.09-.08-12.09-.17,5.41-.16,12.09-.16S175.57,170.9,175.57,171Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 176.19,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.94,
    y: 193.63,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,188.2c0,.09-5.41.17-12.08.17s-12.09-.08-12.09-.17,5.41-.16,12.09-.16S175.57,188.11,175.57,188.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 106.8,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,118.81c0,.09-5.41.17-12.09.17S127,118.9,127,118.81s5.41-.16,12.08-.16S151.19,118.72,151.19,118.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 124.19,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,136.21c0,.09-5.41.16-12.09.16S127,136.3,127,136.21s5.41-.17,12.08-.17S151.19,136.12,151.19,136.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 141.58,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,153.6c0,.09-5.41.16-12.09.16S127,153.69,127,153.6s5.41-.17,12.08-.17S151.19,153.51,151.19,153.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 158.98,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,171c0,.09-5.41.17-12.09.17S127,171.08,127,171s5.41-.16,12.08-.16S151.19,170.9,151.19,171Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 176.37,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,188.38c0,.09-5.41.17-12.09.17s-12.08-.08-12.08-.17,5.41-.16,12.08-.16S151.19,188.29,151.19,188.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.56,
    y: 193.76,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.06,
    y: 115.33,
    width: 48.34,
    height: 153.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.24,
    y: 115.33,
    width: 24.17,
    height: 152.79,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.59,
    y: 100.29,
    width: 17.07,
    height: 15.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.59,
    y: 100.29,
    width: 4.07,
    height: 15.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "300.04 115.33 300.04 114.45 353.82 114.45 353.82 115.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 121.89,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,133.91c0,.09-5.41.16-12.09.16s-12.09-.07-12.09-.16,5.42-.17,12.09-.17S328.24,133.82,328.24,133.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 121.89,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,133.91c0,.09-5.41.16-12.09.16s-12.08-.07-12.08-.16,5.41-.17,12.08-.17S352.62,133.82,352.62,133.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 139.02,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,151c0,.09-5.41.16-12.09.16s-12.08-.07-12.08-.16,5.41-.17,12.08-.17S352.62,151,352.62,151Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 156.67,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,168.69c0,.09-5.41.16-12.09.16s-12.08-.07-12.08-.16,5.41-.17,12.08-.17S352.62,168.6,352.62,168.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 174.32,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,186.33c0,.1-5.41.17-12.09.17s-12.08-.07-12.08-.17,5.41-.16,12.08-.16S352.62,186.24,352.62,186.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 191.46,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,203.48c0,.09-5.41.16-12.09.16s-12.08-.07-12.08-.16,5.41-.17,12.08-.17S352.62,203.39,352.62,203.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 208.67,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 226.11,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,220.69c0,.09-5.41.16-12.09.16s-12.08-.07-12.08-.16,5.41-.16,12.08-.16S352.62,220.6,352.62,220.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 139.28,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,151.3c0,.09-5.41.16-12.09.16s-12.09-.07-12.09-.16,5.42-.16,12.09-.16S328.24,151.21,328.24,151.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 156.68,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,168.69c0,.09-5.41.17-12.09.17s-12.09-.08-12.09-.17,5.42-.16,12.09-.16S328.24,168.6,328.24,168.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 174.07,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,186.08c0,.1-5.41.17-12.09.17s-12.09-.07-12.09-.17,5.42-.16,12.09-.16S328.24,186,328.24,186.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 191.46,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,203.48c0,.09-5.41.16-12.09.16s-12.09-.07-12.09-.16,5.42-.17,12.09-.17S328.24,203.39,328.24,203.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 208.86,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,220.87c0,.09-5.41.16-12.09.16s-12.09-.07-12.09-.16,5.42-.16,12.09-.16S328.24,220.78,328.24,220.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.61,
    y: 226.25,
    width: 4.09,
    height: 8.63,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.49,
    y: 174.78,
    width: 78.28,
    height: 103.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.06,
    y: 174.78,
    width: 36.7,
    height: 103.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.9,
    y: 188.76,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.9,
    y: 255.68,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,212.57c0,.19-9.3.34-20.78.34s-20.79-.15-20.79-.34,9.3-.35,20.79-.35S376.06,212.37,376.06,212.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.9,
    y: 222.47,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,246.28c0,.19-9.3.35-20.78.35s-20.79-.16-20.79-.35,9.3-.35,20.79-.35S376.06,246.09,376.06,246.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.86,
    y: 188.76,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.13,
    y: 188.76,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.86,
    y: 221.2,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.13,
    y: 221.2,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.86,
    y: 253.65,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.13,
    y: 253.65,
    width: 7.04,
    height: 17.1,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.6,
    y: 171.18,
    width: 90.05,
    height: 3.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.31,175.26c0,.19-17.49.34-39.07.34s-39.08-.15-39.08-.34,17.5-.35,39.08-.35S413.31,175.06,413.31,175.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.43 280.08 86.29 280.08 85.98 167.65 157.12 167.65 157.43 280.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.55,
    y: 167.65,
    width: 35.57,
    height: 112.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 145.52,
    width: 25.12,
    height: 22.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.23,
    y: 145.52,
    width: 5.99,
    height: 22.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.05,
    y: 166.36,
    width: 79.15,
    height: 1.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.02,
    y: 177.31,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,195c0,.13-8,.24-17.79.24S86,195.12,86,195s8-.24,17.78-.24S121.55,194.85,121.55,195Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 177.31,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,195c0,.13-8,.24-17.79.24s-17.78-.11-17.78-.24,8-.24,17.78-.24S157.43,194.85,157.43,195Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 202.52,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,220.2c0,.13-8,.24-17.79.24s-17.78-.11-17.78-.24,8-.25,17.78-.25S157.43,220.06,157.43,220.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 228.49,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,246.17c0,.13-8,.24-17.79.24s-17.78-.11-17.78-.24,8-.25,17.78-.25S157.43,246,157.43,246.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9,
    y: 254.45,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,272.14c0,.13-8,.24-17.79.24s-17.78-.11-17.78-.24,8-.25,17.78-.25S157.43,272,157.43,272.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.02,
    y: 202.9,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,220.58c0,.14-8,.24-17.79.24S86,220.72,86,220.58s8-.24,17.78-.24S121.55,220.45,121.55,220.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.02,
    y: 228.49,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,246.17c0,.14-8,.25-17.79.25S86,246.31,86,246.17s8-.24,17.78-.24S121.55,246,121.55,246.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.02,
    y: 254.09,
    width: 6.02,
    height: 12.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,271.77c0,.13-8,.24-17.79.24S86,271.9,86,271.77s8-.24,17.78-.24S121.55,271.63,121.55,271.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.16,144.93c.38-2.74-3.48-5-6.38-5.22a16.68,16.68,0,0,1-4.13-.35c-2.83-1-4-4.66-6.73-5.82-2.07-.88-4.45-.1-6.46.91s-4,2.28-6.23,2.42c-2,.13-4.07-.6-5.77.36-1.27.71-1.94,2.17-3.11,3a7.48,7.48,0,0,1-4.06,1.1,11.31,11.31,0,0,0-4.19.68,3.3,3.3,0,0,0-2.1,3.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,67c.59-4.27-5.45-7.79-10-8.16-2.16-.17-4.41.16-6.45-.55-4.44-1.55-6.22-7.29-10.55-9.12-3.24-1.36-7-.15-10.11,1.43s-6.24,3.57-9.75,3.8c-3,.19-6.37-.94-9,.55-2,1.11-3,3.41-4.86,4.76s-4.14,1.6-6.36,1.72-4.53.15-6.56,1.07-3.7,3.08-3.28,5.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,126.2c.47-3.41-4.34-6.22-8-6.51-1.72-.14-3.51.13-5.15-.44-3.54-1.24-5-5.81-8.4-7.27-2.59-1.09-5.56-.12-8.06,1.14s-5,2.85-7.78,3c-2.43.15-5.07-.75-7.2.44-1.59.88-2.42,2.71-3.88,3.79a9.14,9.14,0,0,1-5.07,1.37,14.4,14.4,0,0,0-5.23.86c-1.61.74-2.95,2.45-2.61,4.19Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locators--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.83,201.41A21.36,21.36,0,0,0,61,235.23h0l.2.29,0,0,15.13,20.57a3.25,3.25,0,0,0,5.31-.11l13.67-20.33c2.58-3.94,4.36-8.07,4.36-12.93A21.36,21.36,0,0,0,77.83,201.41Zm.51,36.89A16.06,16.06,0,1,1,94.4,222.24,16.06,16.06,0,0,1,78.34,238.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.83,201.41A21.36,21.36,0,0,0,61,235.23h0l.2.29,0,0,15.13,20.57a3.25,3.25,0,0,0,5.31-.11l13.67-20.33c2.58-3.94,4.36-8.07,4.36-12.93A21.36,21.36,0,0,0,77.83,201.41Zm.51,36.89A16.06,16.06,0,1,1,94.4,222.24,16.06,16.06,0,0,1,78.34,238.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,201.41a21.43,21.43,0,0,0-20.85,20.83,21.18,21.18,0,0,0,4,13h0l.21.29,0,0,15.12,20.57A3.25,3.25,0,0,0,80.4,256l13.67-20.33c2.59-3.94,4.36-8.07,4.36-12.93A21.36,21.36,0,0,0,76.57,201.41Zm.5,34a12.16,12.16,0,1,1,12.17-12.16A12.16,12.16,0,0,1,77.07,235.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.86,181.16A16.28,16.28,0,0,0,400,206.94h0l.16.22,0,0,11.53,15.67a2.47,2.47,0,0,0,4-.08l10.42-15.49a17.66,17.66,0,0,0,3.33-9.85A16.29,16.29,0,0,0,412.86,181.16Zm.39,28.12A12.24,12.24,0,1,1,425.49,197,12.24,12.24,0,0,1,413.25,209.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.86,181.16A16.28,16.28,0,0,0,400,206.94h0l.16.22,0,0,11.53,15.67a2.47,2.47,0,0,0,4-.08l10.42-15.49a17.66,17.66,0,0,0,3.33-9.85A16.29,16.29,0,0,0,412.86,181.16Zm.39,28.12A12.24,12.24,0,1,1,425.49,197,12.24,12.24,0,0,1,413.25,209.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M411.9,181.16a16.28,16.28,0,0,0-12.83,25.78h0l.15.22,0,0,11.52,15.67a2.48,2.48,0,0,0,4.05-.08l10.42-15.49a17.65,17.65,0,0,0,3.32-9.85A16.28,16.28,0,0,0,411.9,181.16Zm.38,25.91a9.27,9.27,0,1,1,9.27-9.27A9.26,9.26,0,0,1,412.28,207.07Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "89.51 278.19 18.09 455.55 152 433.53 250.21 455.55 350.79 433.53 485.3 459.19 413.29 278.19 332.94 257.95 251.7 273.43 168.67 257.95 89.51 278.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.51,278.19l1.31-.35,3.91-1,15.32-3.95,58.59-15h.05l83,15.43h-.07l81.24-15.5H333L413.34,278l.12,0,0,.11,72,181,.18.44-.47-.09-69.19-13.2-65.32-12.46h.11l-100.59,22,0,0-.06,0-98.2-22H152l-133.92,22-.33.05.13-.31c22.09-54.76,40-99.1,52.34-129.75l14.26-35.27,3.71-9.16c.84-2.06,1.28-3.11,1.28-3.11s-.41,1.07-1.24,3.15l-3.68,9.2L70.42,325.87,18.27,455.62l-.21-.26L152,433.3h.09l98.2,22h-.1l100.58-22,.05,0h0l65.32,12.46,69.19,13.2-.29.35-72-181,.16.14-80.34-20.26H333L251.73,273.6h-.07l-83-15.52h0L110.13,273l-15.35,3.89-3.93,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.68 282.95 30.59 446.62 151.41 426.98 251.7 450.19 350.79 426.39 473.99 450.19 409.12 282.95 334.13 264.5 251.7 279.98 167.48 264.5 93.68 282.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.6 428.44 133.63 406.19 130.09 385.51 138.07 380.48 125.65 332.17 87.25 299.62 37.6 428.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.59 446.62 35.27 434.48 196.29 397.07 205.03 421.14 202.2 426 171.96 431.74 151.41 426.98 30.59 446.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.03 394.74 211.42 418.55 229.97 426.61 256.35 414.89 311.7 398.77 294.43 372.75 205.03 394.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.72 403.56 170.64 397.07 164.67 377.63 142.87 382.89 137.07 386.99 140.72 403.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.61 339.13 145.47 374.78 162.45 371.04 159.39 357.35 196.74 348.98 134.61 339.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.08 292.3 137.07 330.02 199.45 341.85 265.99 325.31 235.62 277.02 167.48 264.5 93.68 282.95 90.08 292.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.71 278.69 342.26 428.44 350.79 426.39 256.37 279.1 251.7 279.98 244.71 278.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.67 361.12 178.03 397.07 287.77 369.03 267.46 334.46 165.67 361.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "226.72 444.41 227.79 442.82 235 432.11 252.29 426.61 264.19 417.65 315.76 403.56 331.78 430.95 251.7 450.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.08 267.51 343.92 296.26 409.12 282.95 334.13 264.5 318.08 267.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.84 318.32 374.96 331.63 350.79 299.62 410.75 287.17 422.84 318.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.49 278.13 311.7 350.25 369.64 333.62 311.7 268.71 261.49 278.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.85 436.25 459.78 413.56 473.99 450.19 401.85 436.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.26 345.94 372.74 337.73 405.99 377.63 373.63 388.37 341.26 345.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.83 334.46 414.86 374.62 441.24 365.76 423.89 321.04 379.83 334.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.99 426.88 379.83 390.59 443.06 370.44 455.9 403.56 447.66 411.85 405.99 426.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.77 355.55 362.83 428.44 392.43 434.43 398.01 431.88 337.11 348.82 314.77 355.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.81 409.86 105.84 353.56 63.62 360.94 37.6 428.44 117.81 409.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.63 267.21 156.63 292.99 165.67 294.13 190.91 323.53 212.61 321.04 222.94 336.01 199.45 341.85 137.07 330.02 90.08 292.3 93.68 282.95 156.63 267.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.59 273.27 324.04 325 354.58 316.75 311.7 268.71 288.59 273.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.66 326.71 379.83 306.66 414.51 296.86 422.84 318.32 392.66 326.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.26 395.73 358.05 389.92 390.61 434.06 362.83 428.44 341.26 395.73",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.41 435.08 202.02 433.18 207.22 425.57 226.72 431.7 221.62 443.23 186.41 435.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.68,283l4.86-1.25,14.28-3.6,54.63-13.73h.05l84.23,15.43h-.07l82.43-15.51h.09l75,18.43.11,0,0,.12C429.2,334,451.13,390.56,474.23,450.1l.17.44-.46-.09-61.81-11.94-61.39-11.87h.11l-99.09,23.8h-.12L151.36,427.21h.09L30.62,446.81l-.32.05.11-.31C49.94,396,65.75,355.08,76.67,326.8c5.47-14.12,9.71-25.09,12.59-32.53l3.29-8.45c.74-1.91,1.13-2.87,1.13-2.87s-.37,1-1.1,2.91l-3.24,8.48-12.51,32.6L30.77,446.69l-.21-.25,120.81-19.68h.09L251.75,450h-.11l99.09-23.81.06,0h0L412.23,438,474,449.94l-.29.35c-23.09-59.55-45-116.07-64.85-167.25l.16.14-75-18.47h.09l-82.44,15.44h-.07l-84.2-15.52h0L112.9,278.21l-14.31,3.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "250.21 455.55 251.7 273.43 168.67 257.95 152 433.53 250.21 455.55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.94 257.95 350.79 433.53 485.3 459.19 413.29 278.19 332.94 257.95"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.34,101.09c-58,1.35-105.31,48.63-106.69,106.63a108.79,108.79,0,0,0,20.55,66.47h0l1.07,1.45.15.21,77.4,105.28a16.62,16.62,0,0,0,27.18-.57l70-104c13.24-20.2,22.32-41.3,22.32-66.18A109.32,109.32,0,0,0,252.34,101.09Zm2.6,188.79a82.19,82.19,0,1,1,82.18-82.19A82.19,82.19,0,0,1,254.94,289.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.34,101.09c-58,1.35-105.31,48.63-106.69,106.63a108.79,108.79,0,0,0,20.55,66.47h0l1.07,1.45.15.21,77.4,105.28a16.62,16.62,0,0,0,27.18-.57l70-104c13.24-20.2,22.32-41.3,22.32-66.18A109.32,109.32,0,0,0,252.34,101.09Zm2.6,188.79a82.19,82.19,0,1,1,82.18-82.19A82.19,82.19,0,0,1,254.94,289.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,101.09c-58,1.35-105.31,48.63-106.69,106.63a108.79,108.79,0,0,0,20.55,66.47h0l1.07,1.45.15.21,77.4,105.28a16.62,16.62,0,0,0,27.18-.57l70-104c13.24-20.2,22.32-41.3,22.32-66.18A109.32,109.32,0,0,0,245.86,101.09Zm2.6,188.79a82.19,82.19,0,1,1,82.18-82.19A82.19,82.19,0,0,1,248.46,289.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.74,269.68c-1.32,1.49-88.23,24.44-89.54,25.93,16.66,5.08,37,9.5,54.42,8.49,9.81-.56,20-2.31,27.8-8.35S300.46,278.3,295.74,269.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M212.74,103.82a22.71,22.71,0,0,0-5.68,20.24c.76,3.46,2.28,7.32.38,10.31s-6.32,3.5-8.09,6.53c-2.1,3.55.7,8,.35,12.14a8.18,8.18,0,0,1-7.77,7.22,31.83,31.83,0,0,0,16.62,4.6q1.8-3.12,3.59-6.24c-1.38,2.21-.5,5.28,1.39,7.07s4.53,2.54,7.1,3A40.47,40.47,0,0,0,255,158",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,125.52c-1.25-2.56-3.07-4.84-4-7.52-2.1-5.75-.15-12.84-3.78-17.77-2.58-3.52-7.2-4.77-11.51-5.46s-8.88-1.15-12.38-3.74c-2.57-1.91-4.28-4.79-6.84-6.7-3.65-2.73-8.54-3.14-13.08-2.79S221.85,83,218,85.65s-6.79,6.94-6.89,11.62c-.05,2.28.55,4.58.15,6.82-.44,2.47-2,4.57-2.87,6.93a12,12,0,0,0,5,13.83l37.5,36.57c7,1.58,22.76-3.73,27.22-9.38S286,132,282.86,125.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43,119.52c0-9.49,5.55-21.49,15-21.08l29.9,5.59a5.56,5.56,0,0,1,5.31,5.32l1.3,71.16.2,0s-5.4,20.44-25.24,15.59c-3.94-1-6-5.06-7-9.35l-.19,0c-.05-.52-.08-1-.12-1.49a46.29,46.29,0,0,1-.75-9.73h0c-.43-5.73-.57-8.08-.57-8s-12.21-1.24-15.7-16.85C213.84,143,213.43,130.07,213.43,119.52Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82,129.25a2,2,0,0,0,2.08,1.92,1.94,1.94,0,0,0,2-1.95,2,2,0,0,0-2.08-1.92A1.94,1.94,0,0,0,240.82,129.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,130.83a2,2,0,0,0,2.08,1.92,1.94,1.94,0,0,0,2-2,2,2,0,0,0-2.08-1.91A1.93,1.93,0,0,0,220.17,130.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83,126.36c.27.33,2-1.1,4.35-1.09s4.09,1.4,4.36,1.06c.13-.15-.14-.75-.89-1.4a5.49,5.49,0,0,0-3.49-1.27A5.39,5.39,0,0,0,216.7,125C216,125.6,215.7,126.21,215.83,126.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,125.82c.32.3,2-1.29,4.49-1.53s4.49.92,4.73.57c.12-.16-.22-.73-1.09-1.28a6.14,6.14,0,0,0-3.83-.85,6,6,0,0,0-3.54,1.63C237.86,125.07,237.65,125.69,237.81,125.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.17,141.73a14.84,14.84,0,0,0-3.58-.41c-.55,0-1.09-.1-1.2-.48a2.79,2.79,0,0,1,.26-1.67c.44-1.37.9-2.82,1.38-4.33,1.91-6.17,3.25-11.22,3-11.3s-2,4.87-3.9,11c-.46,1.52-.89,3-1.31,4.36a3.2,3.2,0,0,0-.15,2.2,1.4,1.4,0,0,0,1,.75,3.71,3.71,0,0,0,1,.07A13.85,13.85,0,0,0,231.17,141.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,167.57A40.19,40.19,0,0,0,252,160.62s-4.44,11.15-20.32,10.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,146.92a3.93,3.93,0,0,1,3.42-1.68,3.66,3.66,0,0,1,2.56,1.17,2.28,2.28,0,0,1,.33,2.59,2.65,2.65,0,0,1-2.81.9,8.25,8.25,0,0,1-2.88-1.49,2.24,2.24,0,0,1-.66-.6.71.71,0,0,1,0-.81",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.67,142.84c-.36,0-.22,2.36-2.13,4.16s-4.45,1.7-4.45,2c0,.15.59.42,1.66.38a5.94,5.94,0,0,0,3.72-1.56,5.17,5.17,0,0,0,1.63-3.48C238.13,143.38,237.83,142.81,237.67,142.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,118.46c.26.58,2.41.16,5,.31s4.68.71,5,.16c.13-.26-.26-.8-1.13-1.32a8.72,8.72,0,0,0-7.59-.36C237.32,117.69,236.88,118.18,237,118.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.06,119.69c.46.47,2.14-.15,4.2-.31s3.83.1,4.2-.45c.16-.26-.15-.74-.94-1.16a6.51,6.51,0,0,0-3.47-.59,6.42,6.42,0,0,0-3.3,1.2C217.05,118.94,216.85,119.46,217.06,119.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,105.39c-1.75-2-4.5-2.79-7.1-3.4a145.68,145.68,0,0,0-34.25-3.79c-1.08,2.52.66,5.5,3,6.89s5.19,1.68,7.86,2.27,5.49,1.69,6.89,4c1.49,2.51,1,5.79,2.35,8.37,2.34,4.44,9.07,5,11.38,9.48,1.75,3.37.23,7.42.24,11.22a13.56,13.56,0,0,0,15.32,13.43q-1.67-20.28-3.32-40.55C267.15,110.55,266.84,107.52,265,105.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,135.48c-2.39-1.6-5.27-2.87-6.5-5.47-1.78-3.78.74-8.88-1.81-12.19-2.32-3-7.8-2.09-10-5.2-1.72-2.43-.49-5-1.33-7.2s-4.39-3.79-6.69-3.19l-14.59,29.11c-.45,9.14-1.5,14.12,1.14,19.06,1.45,2.71,3.21,5.3,4,8.26s.54,6.48-1.67,8.61c11.06-.68,20.52-7.85,29.23-14.72l9.21-7.27a7.33,7.33,0,0,0,2.43-2.68C301.34,140,299.13,137.08,296.75,135.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,149.83a5.32,5.32,0,0,1-1.13.39,10,10,0,0,1-3.45.24,10.6,10.6,0,0,1-5.11-1.9,10.44,10.44,0,0,1-4-6,10.74,10.74,0,0,1-.23-4.25A17.42,17.42,0,0,1,276,134a16.37,16.37,0,0,0,1.51-4.52,5.49,5.49,0,0,0-1.24-4.56c-1.18-1.19-3.08-1.26-4.89-1.71a5,5,0,0,1-2.58-1.4,5,5,0,0,1-1.15-2.77c-.26-2,.34-4,.44-5.87a6.27,6.27,0,0,0-.37-2.8,4,4,0,0,0-1.89-2c-1.74-.91-3.78-.81-5.75-.7a12,12,0,0,1-5.87-.87,10.71,10.71,0,0,1-4.45-3.65,17.55,17.55,0,0,1-2.16-5.05,24.75,24.75,0,0,0-1.77-4.77,11.16,11.16,0,0,0-3.12-3.52,12.38,12.38,0,0,0-14.63,0,15.13,15.13,0,0,0-3.77,3.8,19.58,19.58,0,0,0-2.08,4.1,1.18,1.18,0,0,1,.06-.3c.06-.19.13-.49.27-.85a14.71,14.71,0,0,1,1.54-3.09,15.27,15.27,0,0,1,3.77-4A13,13,0,0,1,234.6,87a13.23,13.23,0,0,1,8.4,2.39,11.62,11.62,0,0,1,3.3,3.68,24.93,24.93,0,0,1,1.83,4.87,17.39,17.39,0,0,0,2.1,4.87,10.16,10.16,0,0,0,4.2,3.42A11.4,11.4,0,0,0,260,107c2-.1,4.13-.24,6.07.77a4.58,4.58,0,0,1,2.19,2.32,6.84,6.84,0,0,1,.42,3.08c-.12,2-.7,3.92-.46,5.77a4.34,4.34,0,0,0,1,2.42,4.56,4.56,0,0,0,2.27,1.23c.87.23,1.78.34,2.68.58a5.31,5.31,0,0,1,2.48,1.3,6.08,6.08,0,0,1,1.38,5.05,16.8,16.8,0,0,1-1.58,4.67,16.62,16.62,0,0,0-1.46,4.21,10.38,10.38,0,0,0,.18,4.06,10.16,10.16,0,0,0,3.8,5.78,10.57,10.57,0,0,0,4.93,1.94A11.85,11.85,0,0,0,288.46,149.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,128.92a2.35,2.35,0,0,1,.49.84,4,4,0,0,1-.09,2.78,4.18,4.18,0,0,1-1.19,1.67,4.37,4.37,0,0,1-2.26.95,5.51,5.51,0,0,1-5.22-2.37,7.46,7.46,0,0,1-1.25-3.23,10.46,10.46,0,0,1,.27-3.72c.53-2.49,1.79-5,1.43-7.8a5.06,5.06,0,0,0-1.79-3.58,5.64,5.64,0,0,0-4.16-.69,13.72,13.72,0,0,1-4.81.18,4.24,4.24,0,0,1-2.18-1.37,6,6,0,0,1-1.14-2.31,19.67,19.67,0,0,1-.28-4.92,10.9,10.9,0,0,0-.89-4.48,11.49,11.49,0,0,0-6-6c-2.57-1.1-5.34-.87-7.83-.67a22.58,22.58,0,0,1-7.09-.12,14.53,14.53,0,0,1-5.34-2.4,14.81,14.81,0,0,1-3.17-3.07,10.73,10.73,0,0,1-1.79-3.29,21.45,21.45,0,0,0,2,3.13,14.82,14.82,0,0,0,8.41,5.19,22.63,22.63,0,0,0,6.94,0c2.49-.22,5.36-.49,8.11.65a12.12,12.12,0,0,1,6.38,6.27,11.53,11.53,0,0,1,.95,4.73,18.81,18.81,0,0,0,.27,4.76,4.12,4.12,0,0,0,2.85,3.22,13.41,13.41,0,0,0,4.58-.18,6.16,6.16,0,0,1,4.6.82,5.66,5.66,0,0,1,2,4,10.73,10.73,0,0,1-.43,4.22c-.35,1.32-.78,2.55-1.07,3.77a9.59,9.59,0,0,0-.29,3.54,6.9,6.9,0,0,0,1.13,3,5.15,5.15,0,0,0,4.8,2.28,4.08,4.08,0,0,0,2.1-.84,3.92,3.92,0,0,0,1.16-1.52,4,4,0,0,0,.2-2.65A8.59,8.59,0,0,0,300.42,128.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,151.63a4.36,4.36,0,0,0,.43,2.86,3.83,3.83,0,0,0,2.6,2,4,4,0,0,0,3.87-1.66,3.78,3.78,0,0,0,.62-2.43,7.73,7.73,0,0,0-.81-2.71c-.84-1.77-2.31-3.62-2.47-6.07a8.94,8.94,0,0,1,2.45-6.79,10.28,10.28,0,0,1,3.16-2.27,15,15,0,0,1,3.82-1.11,20.77,20.77,0,0,0,3.73-.93,5.11,5.11,0,0,0,2.69-2.24,6.29,6.29,0,0,0,.61-3.39,12.57,12.57,0,0,0-.76-3.34c-.75-2.12-1.71-4.16-1.88-6.27a9.82,9.82,0,0,1,1.21-5.59,12.53,12.53,0,0,1,3.15-3.51A24.29,24.29,0,0,0,211,105.8a7.26,7.26,0,0,0,1.47-2.56s0,.07,0,.2a2.69,2.69,0,0,1-.14.57,6,6,0,0,1-1.11,1.95,22.43,22.43,0,0,1-2.54,2.48,12.5,12.5,0,0,0-3,3.46,9.47,9.47,0,0,0-1.08,5.32c.18,2,1.12,4,1.91,6.12a12.87,12.87,0,0,1,.81,3.5,6.82,6.82,0,0,1-.67,3.73,5.77,5.77,0,0,1-3,2.54,21.68,21.68,0,0,1-3.85,1,14.56,14.56,0,0,0-3.67,1.06,9.63,9.63,0,0,0-3,2.12,8.36,8.36,0,0,0-2.32,6.32c.12,2.24,1.49,4,2.36,5.88a8.1,8.1,0,0,1,.82,2.91,4.11,4.11,0,0,1-.74,2.72,4.38,4.38,0,0,1-4.31,1.75,4.23,4.23,0,0,1-3.17-4.44A2.23,2.23,0,0,1,186,151.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,212.61s1.68-13.45,8.16-20.17,33.6-15.14,33.6-15.14,1.12,9.59,7.62,11.9c6.89,2.46,14.67,1.54,19.71-4.32A31.49,31.49,0,0,0,265,172s32.39,3,37.67,11.86,12.11,43.29,12.11,43.29l-30.28,6.43,4.12,59.26H208.2l1.57-55.62-21.9,3.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.53,235.48a5.05,5.05,0,0,1-.11-1.33c0-.86,0-2.11,0-3.64,0-3.08.05-7.32.15-12s.22-8.93.35-12c.06-1.54.12-2.78.18-3.64a4.69,4.69,0,0,1,.17-1.33,5.42,5.42,0,0,1,.1,1.33c0,.86,0,2.11,0,3.64,0,3.08-.05,7.32-.15,12s-.22,8.93-.35,12c-.06,1.53-.13,2.77-.18,3.63A4.69,4.69,0,0,1,278.53,235.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,211.08c.19-.05,2.08,6,4.22,13.43s3.74,13.56,3.55,13.61-2.07-6-4.22-13.42S202.13,211.14,202.31,211.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,181.68c0,.12-1.44.39-3.65,1.23a26.29,26.29,0,0,0-13.62,11.85c-1.14,2.07-1.61,3.48-1.73,3.44a3.31,3.31,0,0,1,.23-1,17.51,17.51,0,0,1,1.06-2.65,24,24,0,0,1,13.9-12.08,17.14,17.14,0,0,1,2.77-.69A2.85,2.85,0,0,1,299.33,181.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,195.15c.18,0,.82,1.83,1.42,4.18s.93,4.3.74,4.35-.82-1.83-1.42-4.18S197.14,195.2,197.33,195.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.44,228.24s-9.07,46.06-10.11,50-2.71,14.55-13.7,16.75c-14.83,3-73.06.89-73.06.89l11-13.9,50.95-14.29,7-33.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,274.2a3.4,3.4,0,0,1,.43,1.06,15.25,15.25,0,0,1,.58,3.08,17.66,17.66,0,0,1-2.08,10A20.35,20.35,0,0,1,218.2,293a11.19,11.19,0,0,1-3.89,2.59,11.31,11.31,0,0,1-3.06.69,3.58,3.58,0,0,1-1.15,0,23.6,23.6,0,0,0,4-1.11,11.34,11.34,0,0,0,3.62-2.58,21.75,21.75,0,0,0,3.18-4.51,18.42,18.42,0,0,0,2.2-9.66C223,275.78,222.47,274.24,222.6,274.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.84,219.69s8.21,27.63,11.61,39.57c3.62,12.68,11.53,41.48,28.39,36.37,12.83-3.9,9.06-20.52,9.06-20.52l-13.13-37.94-10.21,1.71-9.91-25.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41,276.31a14.37,14.37,0,0,0,0-6.25,19.45,19.45,0,0,0-2.74-6.21,54.18,54.18,0,0,0-5.32-6.53,55.1,55.1,0,0,1-5.34-6.64,42,42,0,0,1-3.35-6.1,36.55,36.55,0,0,1-1.64-4.39,6.49,6.49,0,0,1-.4-1.68,10.93,10.93,0,0,1,.65,1.59c.4,1,1,2.5,1.84,4.27a44.64,44.64,0,0,0,3.44,5.95,58.32,58.32,0,0,0,5.32,6.53,50.35,50.35,0,0,1,5.34,6.65A19,19,0,0,1,218.9,270a12,12,0,0,1,0,4.72,7.22,7.22,0,0,1-.35,1.23A1.32,1.32,0,0,1,218.41,276.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,213.29s.06-11-.91-14.14l-7.8-17.42s-2-1.23-3,2.24,2.08,7.05,2.08,7.05l.24,4.56L177.14,193l-6.07-11.38s-4.19-8.29-5.27-7-.73,4,1.07,7.55l4.1,8.12s.62,1.44-1.53-.65-6.82-12.21-7.79-13.48-2.29-5-4.38-4.13.59,5.29.59,5.29l6.69,15s-3.88-5.68-4.58-6.64-2.32-4.21-3.59-5.87-2.66-2.3-3.58-1.9a1.87,1.87,0,0,0-1.16,2.29l7.15,12.4s3.57,5.57,3.57,6-3.12-1.84-3.12-1.84l-3-3.82s-3.24-5.72-4.94-5.41-1.4,1.58-1.4,1.58l6,10.42,8.74,11.24,9.34,9.28,5.4-1.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,211.43A21.57,21.57,0,0,0,173,208c.35-2.06,1.06-5.15,3.59-7.14a6,6,0,0,1,3.63-1.39h.45l0-.48c-.14-2.14-.06-4.18-.14-5.53a5,5,0,0,0-.3-2.19,11.53,11.53,0,0,0-.21,2.18,55.44,55.44,0,0,0-.17,5.67l.41-.48a6.49,6.49,0,0,0-4.19,1.52,9.13,9.13,0,0,0-2.83,3.94,14.73,14.73,0,0,0-.84,3.82A10.7,10.7,0,0,0,172.46,211.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.88,
    y: 309.63,
    width: 138.93,
    height: 44.95,
    rx: 4.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,354.59s.32,0,.92-.12a4.81,4.81,0,0,0,2.36-1.24,4.9,4.9,0,0,0,1.5-4c0-1.76,0-3.78,0-6,0-4.55,0-10.11,0-16.57q0-4.85,0-10.34a19.35,19.35,0,0,0-.09-2.75,4.72,4.72,0,0,0-1.29-2.39,4.65,4.65,0,0,0-2.48-1.29,24.21,24.21,0,0,0-3-.07l-127.06.07a4.6,4.6,0,0,0-4.56,3.95c-.09.71,0,1.51-.05,2.27v31.34c0,.72,0,1.45,0,2.17a4.67,4.67,0,0,0,.41,2,4.61,4.61,0,0,0,3,2.56,7.26,7.26,0,0,0,2,.17H206.2l57.12,0,38.51.09,10.47,0,2.73,0,.92,0-.92,0-2.73,0-10.47.05-38.51.08-57.12.06H187.57a7.79,7.79,0,0,1-2.18-.19,5.11,5.11,0,0,1-3.76-5v-6.54q0-8.77,0-17.85v-9.12a23.14,23.14,0,0,1,.06-2.34,5,5,0,0,1,.89-2.24,5.18,5.18,0,0,1,4.18-2.16l127.06.08a23.86,23.86,0,0,1,3,.09,5,5,0,0,1,4,4,17.79,17.79,0,0,1,.09,2.81q0,5.49,0,10.34c0,6.46,0,12,0,16.57q0,3.4,0,6a5.54,5.54,0,0,1-.41,2.39,5,5,0,0,1-1.18,1.64,4.76,4.76,0,0,1-2.42,1.21,4.51,4.51,0,0,1-.69.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.74,328.53a3.7,3.7,0,0,1,3.94-3.72,3.79,3.79,0,0,1,3.08,1.35l-1.29,1.17a2.09,2.09,0,0,0-1.69-.84,2,2,0,0,0,0,4.09,2.12,2.12,0,0,0,1.69-.84l1.29,1.16a3.79,3.79,0,0,1-3.08,1.35A3.7,3.7,0,0,1,195.74,328.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.51,328.92v-4h2v3.91c0,1.23.51,1.72,1.36,1.72s1.35-.49,1.35-1.72V325h2v4a3.37,3.37,0,0,1-6.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,330.21h-1.11v1.9h-2V325h3.27c2,0,3.18,1,3.18,2.65a2.37,2.37,0,0,1-1.4,2.26l1.54,2.25H216Zm0-3.66h-1.13v2.09h1.13c.83,0,1.25-.38,1.25-1S215.59,326.55,214.76,326.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,330.21h-1.11v1.9h-2V325h3.27c2,0,3.18,1,3.18,2.65a2.37,2.37,0,0,1-1.4,2.26l1.54,2.25H223.6Zm0-3.66h-1.13v2.09h1.13c.84,0,1.26-.38,1.26-1S223.16,326.55,222.32,326.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,330.55v1.56h-5.75V325h5.62v1.57h-3.61v1.2h3.18v1.52h-3.18v1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.41,325v7.16h-1.67l-3.15-3.81v3.81h-2V325h1.67l3.16,3.82V325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,326.56h-2.19V325h6.41v1.61h-2.19v5.55h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,325h2v5.56h3.41v1.6H251.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,328.53a4,4,0,1,1,4,3.72A3.74,3.74,0,0,1,257.06,328.53Zm5.91,0a1.94,1.94,0,1,0-1.94,2.05A1.92,1.92,0,0,0,263,328.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.71,328.53a3.69,3.69,0,0,1,3.93-3.72,3.79,3.79,0,0,1,3.08,1.35l-1.29,1.17a2.09,2.09,0,0,0-1.69-.84,2,2,0,0,0,0,4.09,2.12,2.12,0,0,0,1.69-.84l1.29,1.16a3.79,3.79,0,0,1-3.08,1.35A3.69,3.69,0,0,1,265.71,328.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.29,330.72h-3l-.56,1.39h-2.07l3.16-7.16h2l3.17,7.16h-2.11Zm-.6-1.49-.91-2.29-.92,2.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.69,326.56h-2.2V325h6.41v1.61h-2.18v5.55h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66,325h2v7.16h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76,328.53a4,4,0,1,1,4,3.72A3.74,3.74,0,0,1,290.76,328.53Zm5.91,0a1.94,1.94,0,1,0-1.94,2.05A1.92,1.92,0,0,0,296.67,328.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.58,325v7.16h-1.67l-3.16-3.81v3.81h-2V325h1.67l3.16,3.82V325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,340.47a3.74,3.74,0,0,1,6.49-2.31l-1,.93a2.21,2.21,0,0,0-1.71-.8,2.18,2.18,0,0,0,0,4.36,2.16,2.16,0,0,0,1.71-.81l1,.93a3.73,3.73,0,0,1-6.49-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,337.07h1.58v6.8h-1.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,338.35h-2.18v-1.28h5.93v1.28h-2.18v5.52h-1.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.24,341.46v2.41h-1.57v-2.43L227,337.07h1.67l1.81,3,1.82-3h1.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59,343a2.23,2.23,0,0,1-.27,1l-.55,1.4h-1l.42-1.55a.83.83,0,0,1-.52-.82.94.94,0,0,1,1.88,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,340.47a3.75,3.75,0,0,1,6.5-2.31l-1,.93a2.2,2.2,0,0,0-1.71-.8,2.18,2.18,0,0,0,0,4.36,2.14,2.14,0,0,0,1.71-.81l1,.93a3.74,3.74,0,0,1-6.5-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,340.47a3.73,3.73,0,1,1,3.72,3.52A3.52,3.52,0,0,1,246,340.47Zm5.85,0a2.13,2.13,0,1,0-2.13,2.18A2.08,2.08,0,0,0,251.87,340.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,340.88v-3.81h1.57v3.75c0,1.29.56,1.83,1.52,1.83s1.51-.54,1.51-1.83v-3.75h1.56v3.81a3.08,3.08,0,1,1-6.16,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54,337.07v6.8h-1.29l-3.39-4.13v4.13H262.3v-6.8h1.3L267,341.2v-4.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.56,338.35h-2.18v-1.28h5.93v1.28h-2.18v5.52h-1.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,343.87,279.18,342h-1.45v1.89h-1.58v-6.8h3c1.81,0,2.95.94,2.95,2.47a2.21,2.21,0,0,1-1.4,2.15l1.53,2.18ZM279,338.35h-1.28v2.37H279c1,0,1.45-.44,1.45-1.18S280,338.35,279,338.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,341.46v2.41h-1.57v-2.43l-2.64-4.37h1.67l1.82,3,1.82-3h1.55Z",
    style: {
      fill: "#e0e0e0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d3c70b94596a8f4158108e600db56ef6.svg";
export { ForwardRef as ReactComponent };